import type { TypographyOptions } from '@mui/material/styles/createTypography'

export const typographySet = {
  h1: {
    fontSize: '40px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  h2: {
    fontSize: '34px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  h3: {
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: 'normal',
    letterSpacing: '-1px',
  },
  h4: {
    fontSize: '20px',
    fontWeight: 300,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  headline1: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  headline2: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
  title1: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '-0.5px',
  },
  title2: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '-0.5px',
  },
  title3: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '-0.5px',
  },
  subheading: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: '-0.5px',
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 300,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  subtitle2: {
    fontSize: '16px',
    fontWeight: 700,
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  subtitle3: {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  body1: {
    fontSize: '14px',
    fontWeight: 300,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  body2: {
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  body3: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  body4: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  caption1: {
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  caption2: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  caption3: {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  caption4: {
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  captionTitle1: {
    fontSize: '11px',
    fontWeight: 'normal',
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  captionTitle2: {
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  overline1: {
    fontSize: '10px',
    fontWeight: 'normal',
    letterSpacing: '-0.5px',
    lineHeight: 'normal',
  },
  overline2: {
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '-0.25px',
    lineHeight: 'normal',
  },
  overline3: {
    fontSize: '10px',
    fontWeight: 700,
    letterSpacing: '-0.25px',
    lineHeight: 'normal',
  },
} as const

const typography: TypographyOptions = {
  fontSize: 16,
  fontFamily: '"Noto Sans KR", -apple-system, "Malgun Gothic", sans-serif',
  ...typographySet,
}

export default typography
